import { AxiosError } from "axios";

import type { ErrorHandler } from "./errorHandler.types";

export const unauthorizedHandler: ErrorHandler = (error: AxiosError) => {
  if (error.response?.status !== 401) return false;

  window.location.href = "/login";
  return true;
};
